import { AddressInfoFields } from '../../configuration/steps/default/addressInfo';
import { InputMask } from './inputMask';
import { phoneNumberMask } from './phoneNumberMask';
import { postalCodeMask } from './postalCodeMask';

export const inputMaskMap = new Map<string, InputMask>([
	[AddressInfoFields.Phone, phoneNumberMask],
	[AddressInfoFields.ShippingZip, postalCodeMask],
	[AddressInfoFields.BillingZip, postalCodeMask]
]);
